import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BookOpen, Headphones, FileText, Clock, User } from "lucide-react";

interface NavItem {
  path: string;
  label: string;
  icon: React.ElementType;
}

const navItems: NavItem[] = [
  { path: "/guide", label: "ガイド", icon: BookOpen },
  { path: "/learn", label: "学習", icon: Headphones },
  { path: "/exams", label: "過去問", icon: FileText },
  { path: "/mock", label: "模試", icon: Clock },
  { path: "/mypage", label: "My", icon: User },
];

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900
        border-t border-slate-200 dark:border-slate-700
        pb-[env(safe-area-inset-bottom)] z-30"
      role="navigation"
      aria-label="メインナビゲーション"
    >
      <div className="flex justify-around items-center h-16">
        {navItems.map(({ path, label, icon: Icon }) => {
          const active = isActive(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center gap-1 min-w-[64px] min-h-[44px]
                justify-center transition-colors duration-200 cursor-pointer
                ${active
                  ? "text-blue-500"
                  : "text-slate-400 dark:text-slate-500"
                }`}
              aria-current={active ? "page" : undefined}
              aria-label={label}
            >
              <Icon size={20} />
              <span className="text-xs font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
